$(document).ready(function () {
    const lenis = new Lenis({ smoothWheel: true, duration: 1.5, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), })
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf)
})


document.addEventListener('DOMContentLoaded', function () {
    function updateVariantInfo(label) {
      const price = label.querySelector('.current-price')?.textContent.trim();
      const pricedElement = document.querySelector('.priced');

      if (pricedElement) {
        pricedElement.innerHTML = price || '';
      }
    }
    
    document.body.addEventListener('change', function (event) {
      if (event.target.matches('input[type="radio"][name^="pack of"]')) {
        const selectedRadio = event.target;
        const label = selectedRadio.nextElementSibling;
        if (label) {
          updateVariantInfo(label);
        }
      }
    });
});


$(document).ready(function () {
var other_elements = gsap.utils.toArray("[gsap-fadin-anim]");
other_elements.forEach(function (element) {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top 95%",
      end: "bottom 50%",
      toggleActions: "play none none none",
    },
  });
  tl.fromTo(
    element,
    { opacity: 0, yPercent: 20 },
    { duration: 1, opacity: 1, yPercent: 0, ease: "cubic" }
  );
});
  
var scale_elements = gsap.utils.toArray("[gsap-scale-anim]");
  scale_elements.forEach(function (element) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "top 95%",
        end: "bottom 50%",
        toggleActions: "play none none none",
      },
    });
    tl.fromTo(
      element,
      { opacity: 0, scale: 0.5 },
      { duration: 1, opacity: 1, scale: 1, ease: "cubic" }
    );
  });
});
window.addEventListener("DOMContentLoaded", (event) => {
  // Split text into spans
  let typeSplit = new SplitType("[text-split]", {
    types: "words, chars",
    tagName: "span"
  });
  
  function createScrollTrigger(triggerElement, timeline) {
    // Play tl when scrolled into view (60% from top of screen)
    ScrollTrigger.create({
      trigger: triggerElement,
      onEnter: () => timeline.play()
    });
  }
  
    $("[letters-slide-up]").each(function (index) {
    let tl = gsap.timeline({ paused: true });
    tl.from($(this).find(".char"), { yPercent: 100, duration: 0.6, ease: "power3.out", stagger: { amount: 0.6 } });
    createScrollTrigger($(this), tl);
  });
  
    gsap.set("[text-split]", { opacity: 1 });
});

    $(function () {
        $(".accordian-title").click(function () {
            $(".open").not(this).removeClass("open").next().slideUp(300)
            $(this).toggleClass("open").next().slideToggle(300)
        });
    });

    $(function () {
        $(".collapsible-title").click(function () {
            $(".open").not(this).removeClass("open").next().slideUp(300)
            $(this).toggleClass("open").next().slideToggle(300)
        });
    });